/**
 * Since we don't use any accented text in typeaheads, this is a shim
 * for `diacritics` to prevent it from bloating out the bundle size.
 */
export function clean(input) {
  return input;
}
